import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { ArticleType } from '../shared/Carousel/Carousel.types';
import CarouselWrapper from '../shared/Carousel/CarouselWrapper/CarouselWrapper';
import UiHeading from '../shared/Heading';
import UiBox from '../shared/Box';

const ArticleCarousel = (props: ArticleType): JSX.Element => {
  const theme = useTheme();
  if (!props?.fields) return <></>;
  return (
    <Box
      sx={{
        backgroundColor: theme.palette.white.main,
        maxWidth: '1365px',
        marginInline: 'auto',
      }}
      id="article-carousel"
      className="ui-article-carousel"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '48px 41px',
          maxWidth: 'calc(100vw - 10px)',
        }}
      >
        <UiBox styles={{ marginBottom: '1rem' }}>
          <UiHeading size="h2" align="center">
            {props?.fields?.sectionTitle}
          </UiHeading>
        </UiBox>
        <CarouselWrapper {...props} callerComponent="Articles" />
      </Box>
    </Box>
  );
};

export default ArticleCarousel;
